module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/check-2b95ca8c57b57d8ff6b80d30c843585f.svg";